import React from "react";
import Anchors from "./Anchors";
import { LinkItem } from "./LinkItem";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";

type LinksProps = {
  background: string;
  data: Array<LinkItem>;
  hideOnMobile: boolean;
  sticky: boolean;
};

const Links: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const {
    background,
    data: items = [],
    hideOnMobile,
    sticky,
  } = blockData as LinksProps;
  return (
    <Anchors
      background={background}
      links={items}
      hideOnMobile={hideOnMobile}
      sticky={sticky}
    />
  );
};

export default Links;
